import { Button } from "~/components";

const About = () => {
  return (
    <section
      style={{
        background:
          'linear-gradient(270deg, rgba(9, 18, 39, 0.00) 53.23%, rgba(9, 18, 39, 0.70) 81.97%), linear-gradient(178deg, #091227 0.08%, rgba(9, 18, 39, 0.50) 13.91%, rgba(9, 18, 39, 0.00) 85.77%, #091227 98.39%), url("/img/read-more.jpg") lightgray 50% / cover no-repeat',
      }}
      className="max-md:py-8 max-md:mt-[18px] py-64 mt-[-4px] min-h-[612px]"
      id="about"
    >
      <div className="max-md:min-h-[inherit] container">
        <div className="max-md:w-full max-md:min-h-[inherit] max-md:grid max-md:grid-rows-[max-content_max-content_1fr] max-w-full w-[497px]">
          <h2 className="max-lg:text-4xl max-lg:leading-[49px] text-center text-white text-5xl font-extrabold leading-[60px]">
            Read More <br />
            Pay Less
          </h2>

          <p className="max-lg:mt-4 max-lg:mb-8 max-lg:text-xl max-lg:leading-7 text-center text-white text-2xl font-light font tracking-tight mt-4 mb-12">
            Unlimited Listening for one <br />
            affordable price. No hidden costs.
          </p>

          <div className="max-md:items-end flex justify-center">
            <Button className="max-md:w-full max-md:px-0 px-24" />
          </div>
        </div>
      </div>
    </section>
  );
};

About.disolayName = "About";
export default About;
